import axios from "axios";
import { apiConfig } from "../config";

export const get = async (url, params) => {
  return axios
    .create({
      responseType: "json",
      baseURL: apiConfig.baseUrl
    })
    .get(url, {
      params
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return null;
    });
};

export const getOutsideApi = async (url, params) => {
  return axios
    .create({
      responseType: "json"
    })
    .get(url, {
      params
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return null;
    });
};
